import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import { TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";

export default {
    defaultProps: {
        css: css`
            display: flex;
            line-height: ${TYPOGRAPHY.lineHeight.small};

            input {
                position: absolute;
                clip: rect(0, 0, 0, 0);
                &:focus {
                    clip: unset;
                }

                & + label {
                    margin: 0;
                    cursor: pointer;

                    &::before {
                        border-width: 2px;
                        margin-right: 0.7em;
                        flex-shrink: 0;
                    }
                }

                &:focus + label::before {
                    box-shadow: 0 0 0 2px ${getProp("theme.focus.color")};
                }

                &:checked:not(:disabled) + label::before {
                    border-color: ${getColor("primary")};
                    background: ${getColor("common.background")};
                }

                &:checked:not(:disabled) + label::after {
                    background: ${getColor("primary")};
                }
            }
        `,
    },
};
